<div ngbDropdown #myDropdown="ngbDropdown" class="dropdown" [placement]="'auto'" container="body" autoClose="outside">
    <button class="btn dropdown-toggle date-dropdown-button" ngbDropdownToggle id="dropdownMenuButton"
      aria-expanded="false">
      <img src="assets/images/calander.png" alt="calendar" style="width: 20px; height: 20px;">
      Select a Date
    </button>
  
    <div ngbDropdownMenu aria-labelledby="dropdownMenuButton" class="dropdown-menu">
      <div
      style="display: flex; justify-content: space-between;"
      >
        <div
        style="flex: 1;"
        >
          <div *ngFor="let date of dates.slice(
          0,
          dates.length % 2 === 0 ? dates.length / 2 : dates.length / 2 + 1
        )" class="dropdown-item dropdown-list">
            <div class="innerBody" (click)="onDateSelect(date.value)">
              <label class="label-color">{{ date.text }}</label>
              <input type="radio" [value]="date.value">
            </div>
          </div>
        </div>
  
        <div
        style="flex: 1;"
        >
          <div *ngFor="let date of dates.slice(
          dates.length % 2 === 0 ? dates.length / 2 : dates.length / 2 + 1,
          dates.length
        )" class="dropdown-item dropdown-list">
            <div class="innerBody" (click)="onDateSelect(date.value)">
              <label class="label-color">{{ date.text }}</label>
              <input type="radio" [value]="date.value">
            </div>
          </div>
  
        </div>
  
      </div>
    </div>
  </div>